<template>
  <div
    :class="$style['wrapper']"
    class="feature-request-wrapper"
  >
    <ds-button
      orange
      @click="toggleWindow"
    >
      Zaproponuj nową funkcję
    </ds-button>
    <div
      v-if="open"
      :class="$style['window-wrapper']"
    >
      <ds-content-box v-if="!sended">
        <div
          slot="header"
          class="content-header"
        >
          <span class="content-title">
            Zaproponuj funkcję, której nie ma w naszym Toolboxie
          </span>
        </div>
        <div slot="content">
          <div
            class="gray-background-inner"
          >
            <ds-loader
              :is-loading="false"
              full-height
            >
              <feature-request-form @onSubmit="onSubmit" />
            </ds-loader>
          </div>
        </div>
      </ds-content-box>
      <div
        v-if="sended"
        :class="$style['sended']"
      >
        <ds-succeeded-icon />
        <div>Dziękujemy za wysłanie propozycji</div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureRequestForm from "../forms/feature-request-form";

export default {
  components: {
    FeatureRequestForm
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sendingError: false,
      sended: false
    };
  },
  watch: {
    open: function() {
      this.sended = false;
    }
  },
  methods: {
    toggleWindow() {
      this.$emit("open");
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sended = true;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.feature-request-wrapper {
  .error-box {
    display: none;
  }
}
</style>


<style lang="scss" module>
@import "~@theme/scss/_variables.scss";

.wrapper {
  position: fixed;
  bottom: 20px;
  left: 35px;
  z-index: 10;
}
.window-wrapper {
  position: relative;
  > div {
    min-width: 460px;
    position: absolute;
    bottom: 40px;
  }
}

.sended {
  font-weight: 600;
  font-size: $font-big-size;
  background-color: #fff;
  padding: 80px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/feature-request.vue